import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import DmtIcon from 'Components/DashboardIcon/DmtIcon';
import { LOGOUT } from 'ConstComponents';
import { Container, Paper, IconButton } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MultiActivePPI as PPI_MULTI_ACTIVE } from 'Components/Api/PPISettingAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import { useHistory } from 'react-router';
export const PPITransaction = ({ isDMTOne }) => {
    const history = useHistory();

    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [Actives, setActive] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const classes = commonStyle();
    const CustomContainer = HOCLoader(Container);

    const selectActivePPI = async () => {
        const response = await PPI_MULTI_ACTIVE(); 
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        let data = JSON.parse(response.data);
        if (data.length <= 1) {
            handleClick(
                data[0].Name,
                data[0].IsCommonPPI,
                data[0].ProviderCode
            );
        }
        setActive(data);  
    };

    const handleClick = (name, IsCommonPPI, ProviderCode) => {
        if (IsCommonPPI === true) {
            let param = {
                DMTName: name
            }; 
            history.push('/KYCPPI_SenderSearch', param);
            return;
        }

        if (name.toLowerCase() === 'PayPoint'.toLowerCase()) {
            let param = {
                DMTName: name
            };
            history.push('/PPISenderAdd', param);
            return;
        }
        else if (name.toLowerCase() === 'PaySprint'.toLowerCase()) {
            let param = {
                DMTName: name
            };
            history.push('/PS_PPIAgentRegistration', param);
            return;
        }
        else if (name.toLowerCase() === 'ICICI_Composite_KYC'.toLowerCase()) {
            let param = {
                DMTName: name
            };
            history.push('/KYCPPI_SenderSearch', param);
            return;
        }
    };

    useEffect(() => {
        selectActivePPI();
    }, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Paper className={classes.PaperStyle}>
                <Grid container>
                    {Actives.map((item) => (
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={2}
                            xl={2}
                            className="text-center"
                        >
                            <IconButton
                                color="primary"
                                className="dashmenu"
                                component="div"
                                onClick={() => {
                                    handleClick(
                                        item.Name,
                                        item.IsCommonPPI,
                                        item.ProviderCode
                                    );
                                }}
                            >
                                <DmtIcon name={item.DisplayName} />
                            </IconButton>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </CustomContainer>
    );
};
